import { useState, useEffect } from "react";
import { getSumOfArrayOfObjects } from "../../utils/calcHelpers"; 

export default function useCarrierCharges(carrierExtraPay, carrier) {
  const [carrierFuel, setCarrierFuel] = useState([]);
  const [carrierFuelByCarrier, setCarrierFuelByCarrier] = useState([]);
  const [carrierFuelTotalByCarrier, setCarrierFuelTotalByCarrier] = useState("");
  const [carrierAccessorialsByCarrier, setCarrierAccessorialsByCarrier] = useState([]);
  const [carrierComcheckAccessorials, setCarrierComcheckAccessorials] = useState([]);
  const carrierFuelCode = "FS";
  const comcheckAccessorialCodes = ["LUM", "PLT", "LAT"];

  useEffect(() => {
    if (carrierExtraPay && carrier) {
      setCarrierFuel(carrierExtraPay.filter(pay => pay.deductCodeId === carrierFuelCode));
      setCarrierFuelByCarrier(carrierExtraPay.filter(pay => 
        pay.deductCodeId === carrierFuelCode && pay.carrierId === carrier.id
      ));
      setCarrierAccessorialsByCarrier(carrierExtraPay.filter(pay =>
        pay.carrierId === carrier.id && pay.deductCodeId !== carrierFuelCode
      ));
      setCarrierComcheckAccessorials(carrierExtraPay.filter(pay => 
        pay.carrierId === carrier.id && comcheckAccessorialCodes.includes(pay.deductCodeId)
      ));
    } else {
      setCarrierFuel([]);
      setCarrierFuelByCarrier([]);
      setCarrierAccessorialsByCarrier([]);
      setCarrierComcheckAccessorials([]);
    }
  }, [carrierExtraPay, carrier]);

  useEffect(() => {
    if (carrierFuelByCarrier) {
      setCarrierFuelTotalByCarrier(getSumOfArrayOfObjects(carrierFuelByCarrier, "amount"));
    } else {
      setCarrierFuelTotalByCarrier("");
    }
  }, [carrierFuelByCarrier, carrier]);

  return { 
    carrierFuel,
    carrierFuelTotalByCarrier,
    carrierAccessorialsByCarrier,
    carrierComcheckAccessorials
  };
}